import { render, staticRenderFns } from "./TranslationToolTextDisplay.vue?vue&type=template&id=8b883390&scoped=true"
import script from "./TranslationToolTextDisplay.vue?vue&type=script&lang=js"
export * from "./TranslationToolTextDisplay.vue?vue&type=script&lang=js"
import style0 from "./TranslationToolTextDisplay.vue?vue&type=style&index=0&id=8b883390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b883390",
  null
  
)

export default component.exports